import React from "react";
import RegistriRizikaRow from "../registriRizikaRow";

export const RegistriRizikaList = React.forwardRef((props, ref) => {
  const filterForms = (list, unit, process) => {
    const filteredMapsByUnit =
      unit.name === "ALL"
        ? list
        : list.filter(
            (process) =>
              process.business_process_list.business_process_id === unit.id
          );

    if (process) {
      const filteredMapsByProcesses =
        process.name === "ALL"
          ? filteredMapsByUnit
          : filteredMapsByUnit.filter(
              (pr) => pr.business_process_list_id === process.id
            );

      return filteredMapsByProcesses;
    }

    return filteredMapsByUnit;
  };

  return (
    <ul>
      {filterForms(
        props.riskForms,
        props.activeUnit,
        props.selectedProcess
      ).map((form, index) => {
        return (
            <RegistriRizikaRow
              key={form.id}
              row={form}
              redniBroj={index + 1}
              riskGroups={props.riskGroups}
              columnWidths={props.columnWidths}
            />
          );
      })}
    </ul>
  );
});
